/* Витрати постачальників в Enote (supply.supplier_enote, supply.invoice_enote_link). Kept apart from supply.ts to keep merges small. */
export const supplyEnoteUk = {
  'supply.enote.title': 'Витрати в Enote',
  'supply.enote.hint':
    'Кожну накладну шукаємо серед «Поступлень товарів» Enote контрагентів цього постачальника: сума ± 1 грн і дата ± 5 днів або той самий номер документа (до місяця). Enote лише читаємо.',
  'supply.enote.column': 'В Enote',
  'supply.enote.attentionFilter': 'Увага: безнал не внесено',
  'supply.enote.attentionN': 'Увага: {n}',
  'supply.enote.foundN': 'Знайдено: {n}',
  'supply.enote.cashN': 'Готівка: {n}',
  'supply.enote.unknownN': 'Невідомо: {n}',
  'supply.enote.markedN': 'Позначено: {n}',
  'supply.enote.none': 'Накладних немає',
  'supply.enote.run': 'Знайти в Enote',
  'supply.enote.runDone': 'Нових збігів: {n}. Увага (безнал не внесено): {a}.',
  'supply.enote.allStatuses': 'Усі статуси',
  'supply.enote.invoices': 'Накладні та статус в Enote',
  'supply.enote.noInvoices': 'Немає накладних із таким статусом.',
  'supply.enote.contragents': 'Контрагенти Enote цього постачальника',
  'supply.enote.noContragents': 'Жодного контрагента Enote не пов’язано — накладні не знайдуться автоматично. Оберіть контрагента нижче.',
  'supply.enote.addContragent': 'Пов’язати контрагента Enote',
  'supply.enote.chooseContragent': 'Оберіть контрагента',
  'supply.enote.link': 'Пов’язати',
  'supply.enote.unlink': 'Відв’язати',
  'supply.enote.reject': 'Не цей',
  'supply.enote.autoAgain': 'Автоматично',
  'supply.enote.receiptsN': 'поступлень: {n}',
  'supply.enote.alsoOf': 'також у: {names}',
  'supply.enote.doc': 'Документ Enote',
  'supply.enote.docLine': '№{n} від {date}',
  'supply.enote.incoming': 'вх. №{n}',
  'supply.enote.pickDoc': 'Обрати документ Enote',
  'supply.enote.pickTitle': 'Документ Enote для накладної',
  'supply.enote.pickHint': 'Спершу — поступлення контрагентів цього постачальника, найближчі за сумою та датою.',
  'supply.enote.ownSupplier': 'цей постачальник',
  'supply.enote.linkedTo': 'вже в накладній №{n}',
  'supply.enote.noCandidates': 'Поступлень поруч за датою немає.',
  'supply.enote.deleted': 'позначено на вилучення в Enote',
  'supply.enote.notPosted': 'не проведено в Enote',
  'supply.enote.matchAuto': 'знайдено автоматично',
  'supply.enote.matchManual': 'пов’язано вручну',
  'supply.enote.matchRejected': 'автопошук вимкнено для цієї накладної',
  'supply.enote.paymentKind': 'Оплата',
  'supply.enoteStatus.found': 'Є в Enote',
  'supply.enoteStatus.marked': 'Позначено внесеною',
  'supply.enoteStatus.attention': 'Безнал не внесено',
  'supply.enoteStatus.cash': 'Не знайдено · готівка',
  'supply.enoteStatus.unknown': 'Не знайдено · оплата невідома',
  'supply.payKind.cash': 'готівка',
  'supply.payKind.bank': 'безготівка',
  'supply.payKind.unknown': 'невідомо',
  'supply.via.enote_ref': 'за посиланням Enote',
  'supply.via.edrpou': 'за ЄДРПОУ',
  'supply.via.name': 'за назвою',
  'supply.via.manual': 'вручну',
  'supply.via.rejected': 'відхилено',
  'supply.event.enote_matched': 'Знайдено в Enote',
  'supply.event.enote_unmatched': 'Документ Enote зник — зв’язок знято',
  'supply.event.enote_link': 'Пов’язано з документом Enote',
  'supply.event.enote_unlink': 'Відв’язано від документа Enote',
  'supply.event.enote_auto': 'Автопошук в Enote увімкнено',
}

export const supplyEnoteEn: { [K in keyof typeof supplyEnoteUk]?: string } = {
  'supply.enote.title': 'Expenses in Enote',
  'supply.enote.hint':
    'Each invoice is looked up among the Enote goods receipts of this supplier’s contragents: amount ± 1 UAH and date ± 5 days, or the same document number (within a month). Enote is only read.',
  'supply.enote.column': 'In Enote',
  'supply.enote.attentionFilter': 'Attention: non-cash not entered',
  'supply.enote.attentionN': 'Attention: {n}',
  'supply.enote.foundN': 'Found: {n}',
  'supply.enote.cashN': 'Cash: {n}',
  'supply.enote.unknownN': 'Unknown: {n}',
  'supply.enote.markedN': 'Marked: {n}',
  'supply.enote.none': 'No invoices',
  'supply.enote.run': 'Find in Enote',
  'supply.enote.runDone': 'New matches: {n}. Attention (non-cash not entered): {a}.',
  'supply.enote.allStatuses': 'All statuses',
  'supply.enote.invoices': 'Invoices and Enote status',
  'supply.enote.noInvoices': 'No invoices with this status.',
  'supply.enote.contragents': 'Enote contragents of this supplier',
  'supply.enote.noContragents': 'No Enote contragent is linked — invoices will not be found automatically. Pick one below.',
  'supply.enote.addContragent': 'Link an Enote contragent',
  'supply.enote.chooseContragent': 'Choose a contragent',
  'supply.enote.link': 'Link',
  'supply.enote.unlink': 'Unlink',
  'supply.enote.reject': 'Not this one',
  'supply.enote.autoAgain': 'Automatic',
  'supply.enote.receiptsN': 'receipts: {n}',
  'supply.enote.alsoOf': 'also in: {names}',
  'supply.enote.doc': 'Enote document',
  'supply.enote.docLine': '№{n} of {date}',
  'supply.enote.incoming': 'inc. №{n}',
  'supply.enote.pickDoc': 'Choose Enote document',
  'supply.enote.pickTitle': 'Enote document of the invoice',
  'supply.enote.pickHint': 'Receipts of this supplier’s contragents first, closest by amount and date.',
  'supply.enote.ownSupplier': 'this supplier',
  'supply.enote.linkedTo': 'already on invoice №{n}',
  'supply.enote.noCandidates': 'No receipts near this date.',
  'supply.enote.deleted': 'marked for deletion in Enote',
  'supply.enote.notPosted': 'not posted in Enote',
  'supply.enote.matchAuto': 'found automatically',
  'supply.enote.matchManual': 'linked by hand',
  'supply.enote.matchRejected': 'automatic search is off for this invoice',
  'supply.enote.paymentKind': 'Payment',
  'supply.enoteStatus.found': 'In Enote',
  'supply.enoteStatus.marked': 'Marked as entered',
  'supply.enoteStatus.attention': 'Non-cash not entered',
  'supply.enoteStatus.cash': 'Not found · cash',
  'supply.enoteStatus.unknown': 'Not found · payment unknown',
  'supply.payKind.cash': 'cash',
  'supply.payKind.bank': 'non-cash',
  'supply.payKind.unknown': 'unknown',
  'supply.via.enote_ref': 'by Enote ref',
  'supply.via.edrpou': 'by ЄДРПОУ',
  'supply.via.name': 'by name',
  'supply.via.manual': 'by hand',
  'supply.via.rejected': 'rejected',
  'supply.event.enote_matched': 'Found in Enote',
  'supply.event.enote_unmatched': 'Enote document gone — link removed',
  'supply.event.enote_link': 'Linked to an Enote document',
  'supply.event.enote_unlink': 'Unlinked from the Enote document',
  'supply.event.enote_auto': 'Automatic Enote search on',
}
